window.PhoneCall = {

    prepareAddCallForm: function (callback) {

        $.mask.definitions['5'] = '[0-5]';
        $(".dayEntry").mask("99:59:59", { placeholder: "-", replacement: '0' });

        Annotation.initResizeTextarea($('#phonecall_note'), true);

        var formId = "addCallForm";
        var options = {
            success: function (data) {
                PhoneCall.recordAddCallCallback({...data, formId: formId}, callback);
            },
            dataType: "json"
        };
        var params = { action: 'addCallRecord' };
        MyForm.prepare(formId, "phonecall_listing&" + $.param(params), options, true);
        MyFacture.initEvent("#addCallForm");
    },

    recordAddCallCallback: function (data, callback) {
        var formIsOk = MyForm.processJson(data, data.formId);
        if (!formIsOk) {
            Push.error(Loc.g('Une erreur est survenue lors de l‘enregistrement de l‘appel <br>') + data.msg, Loc.g('Erreur'));
            MyWindow.awake();
            MyWindow.enable();
        } else if (typeof callback === 'function') {
            callback(data);
            Panel.prototype.close();
        } else {
            Utils.reload();
        }
    },

    toggleMoreInfo: function (blockid) {
        var el = $('.cd-timeline-data.block_' + blockid + ' .cd-more-info-block');
        var elParent = $('.cd-timeline-data.block_' + blockid);

        if (el.is(":visible")) {
            el.hide();
            elParent.parent().find('a.cd-read-more').html(Loc.g('Afficher le résumé'));
            elParent.find('#phone-call-activity-note .EIP_displayer').addClass('reduceNote');
        } else {
            el.show();
            elParent.parent().find('a.cd-read-more').html(Loc.g('Masquer le résumé'));
            elParent.find('#phone-call-activity-note .EIP_displayer').removeClass('reduceNote');
        }
    },

    confirmDeleteCall: function (callid) {
        var options = {
            resizable: false,
            noclose: true,
            type: "warning",
            title: Loc.g("Suppression d'un appel"),
            buttons: [
                {
                    text: Loc.g("Annuler"),
                    click: function () {
                        $(this).dialog("close");
                    }
                },
                {
                    text: Loc.g("Valider"),
                    click: function () {
                        PhoneCall.deleteIt(callid);
                        $(this).dialog("close");
                    }
                }
            ]
        };

        MyWindow.alert(Loc.g("Valider pour supprimer l'appel."), options);
    },

    deleteIt: function (callid) {
        var datas = {
            'action': "delete",
            'callid': callid
        };
        MyFacture.post("phonecall_listing", datas, function (data) {
            PhoneCall.deleteItCallback(data);
        }, "json");
        return true;
    },

    deleteItCallback: function (data) {
        Utils.reload();
    },

    setContactToken: function (item) {
        var more = item.id.replace('corporation_', 'thirdid_');
        $('#phonecall_peopleid').tokenInput("clear");
        $('#phonecall_peopleid').tokenInput("more", more);
        $('#phonecall_linkedelementid').tokenInput("clear");
        $('#phonecall_linkedelementid').tokenInput("more", item.id.replace('corporation_', ''));
    },

    clearContactToken: function () {
        $('#phonecall_peopleid').tokenInput("clear");
        $('#phonecall_peopleid').tokenInput("more", "");
        $('#phonecall_linkedelementid').tokenInput("clear");
        $('#phonecall_linkedelementid').tokenInput("more", "");
    },

    checkPhonecallIsDone: function (selectedValue = null) {
        const isDone = $('#phonecall_mark_as_done').is(':checked');
        const select = $('#phonecall_result');

        if (isDone) {
            for (const child of select.children()) {
                if(child.value === 'scheduled') {
                    $(child).hide();
                } else {
                    $(child).show();
                }
            }
            if( selectedValue !== null && selectedValue !== 'scheduled' ) {
                select.val(selectedValue);
            } else {
                select.children().first().prop('selected', true);
            }
            $('#phonecall_duration_div').show();
        } else {
            for (const child of select.children()) {
                if(child.value !== 'scheduled') {
                    $(child).hide();
                } else {
                    $(child).show();
                }
            }
            if (selectedValue !== null && selectedValue === 'scheduled') {
                select.val(selectedValue);
            } else {
                select.val('scheduled');
            }
            $('#phonecall_duration_div').hide();
        }
    },

    addCall: function(linkedid, linkedtype, callid, callback, isDone = null){
        var title = Loc.g('Ajouter un appel');
        if (callid != 0){
            var title = Loc.g('Modifier un appel');
        }
        var settings = {
            title: title,
            buttons: [
                {
                    name: Loc.g('Fermer'),
                    action: function () {
                        Panel.prototype.close();
                    },
                },
                {
                    name: Loc.g("Enregistrer"),
                    action: function () {
                        $("#addCallForm").submit();
                    },
                    class: "btn-primary"
                }
            ],
            close: true,
            class: 'btn-primary',
            id: '',
            width: 'small',
            callback: function (data) {
                Qtip.init();
                MyFacture.customForm();
                PhoneCall.prepareAddCallForm(callback);
            },
            beforeOpen: function () { },
            afterOpen: function () {
                const select = $('#phonecall_result');
                const selectedValue = select.val();
                const checkMarkAsDone = $('#phonecall_mark_as_done');
                if (isDone ?? selectedValue !== 'scheduled') {
                    checkMarkAsDone.prop('checked', true);
                    PhoneCall.checkPhonecallIsDone(selectedValue)
                } else {
                    checkMarkAsDone.prop('checked', false);
                    PhoneCall.checkPhonecallIsDone(selectedValue)
                }
                checkMarkAsDone.on('click', () => PhoneCall.checkPhonecallIsDone(selectedValue));
            },
            beforeClose: function () { },
            afterClose: function () { }
        };
        var panel = new Panel(settings);
        panel.open('phonecall_listing', { action: 'addCallForm', linkedid: linkedid, linkedtype: linkedtype, callid: callid, isDone: isDone });
    },

    seeCall: function (linkedid, linkedtype, callid) {
        var title = Loc.g('Appel');
        var settings = {
            title: title,
            buttons: [
                {
                    name: Loc.g('Close'),
                    action: function () {
                        Panel.prototype.close();
                    }
                },
                {
                    name: Loc.g("Modifier"),
                    action: function () {
                        PhoneCall.addCall(linkedid, linkedtype,  callid);
                    }
                }
            ],
            close: true,
            class: 'btn-primary',
            id: '',
            width: 'small',
            callback: function (data) { },
            beforeOpen: function () { },
            afterOpen: function () { },
            beforeClose: function () { },
            afterClose: function () { }
        };
        var panel = new Panel(settings);
        panel.open('phonecall_listing', { action: 'seeCall', linkedid: linkedid, linkedtype: linkedtype, callid: callid });
    },

}


window.PhoneCallPrefs = {
    initPrefs: function () {

        var formID = 'phonecallPrefsForm';

        var options = {
            data: { action: "recordPrefs" },
            dataType: 'json',
            success: function (data) {
                var formIsOk = MyForm.processJson(data, formID);

                if (formIsOk) {
                    Push.success(Loc.g('Vos préférences ont bien été modifiées.'), Loc.g('Modifications réussies'));
                } else {
                    Push.error(Loc.g("Une erreur s'est produite lors de la modification de vos préférences."), Loc.g('Erreur'));
                }
            }
        };

        MyForm.prepare(formID, 'phonecall_prefs', options);

    },

    updateStaffCallType: function (staffid) {

        var calltypeid = $('#phonecall_calltypeid_' + staffid).val();
        var datas = {
            action: "updateStaffCallType",
            staffid: staffid,
            calltypeid: calltypeid
        };

        MyFacture.post("phonecall_prefs", datas, function (data) {
            if (data.status == 'ok') {
                Push.success(Loc.g('Le sujet d‘appel a bien été mis à jour.'), Loc.g('Qualification réussie'));
            } else {
                Push.error(Loc.g("Une erreur s'est produite lors de la mise à jour du collaborateur."), Loc.g('Erreur'));
            }
        }, "json");

    }
}
